module.exports = __webpack_public_path__ + "img/ts.34f3a452.svg";